var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00071 3.51902C9.56671 2.11333 11.9867 2.16 13.4951 3.67157C15.0036 5.18315 15.0554 7.59133 13.6524 9.162L7.99997 14.8233L2.34763 9.162C0.94474 7.59133 0.99718 5.17934 2.50495 3.67157C4.01442 2.1621 6.43017 2.11125 8.00071 3.51902Z",
    fill: "#207DF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b9c7528509653340ea10fdee02a2e8ef.svg";
export { ForwardRef as ReactComponent };